const elevionEqualityComparators = ['==', '!='] as const;
export const elevionBooleanComparators = [
  ...elevionEqualityComparators,
] as const;
export const elevionStringComparators = [
  ...elevionEqualityComparators,
  'begins_with',
  'ends_with',
  'matches', // regex - https://github.com/dixahq/elevion/blob/f07a08fb5b0229925b1e42a2efad12870e3d46e1/elevion/src/test/scala/com/elevio/elevion/parser/ElevionParserTest.scala#L25
] as const;
export const elevionArrayComparators = [
  'contains_one',
  'contains_all',
  'is_empty',
] as const;
export const elevionHtzComparators = ['between', 'not_between'] as const;

export const elevionNumberComparators = [
  ...elevionEqualityComparators,
  '>',
  '<',
] as const;

export const elevionDateComparators = [
  'before',
  'after',
  ...elevionNumberComparators,
] as const;

export const elevionTimeComparators = elevionDateComparators;

/** All the possible comparators for an Elevion leaf node. */
export const elevionComparators = [
  // remove duplicates using Set
  ...new Set([
    ...elevionBooleanComparators,
    ...elevionStringComparators,
    ...elevionArrayComparators,
    ...elevionHtzComparators,
    ...elevionDateComparators,
    ...elevionTimeComparators,
    ...elevionNumberComparators,
  ]),
] as const;

export const elevionComparatorLabels: Record<
  (typeof elevionComparators)[number],
  string
> = {
  '==': 'Equals',
  '!=': 'Does not equal',
  begins_with: 'Begins with',
  ends_with: 'Ends with',
  matches: 'Matches',
  contains_one: 'Contains one of',
  contains_all: 'Contains all of',
  is_empty: 'Is empty',
  between: 'Between',
  not_between: 'Not between',
  '>': 'Greater than',
  '<': 'Less than',
  before: 'Before',
  after: 'After',
} as const;

export const elevionCustomAttributePrefix = 'custom__' as const;
export const elevionSystemAttributePrefix = 'system__' as const;
export const elevionSystemAttributes = ['queue'] as const;

export enum ElevionLeafFieldID {
  Queue = 'system__queue',
}
